import styled from 'styled-components'
import TProps from './types'

export const TextComponent = styled.p<TProps>`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  text-align: left;
  color: ${props => props.theme.primaryTextColor};
`